import React, { useEffect, useState, useRef } from 'react';
import SideNavbar from './helpers/SideNavbar';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faImage, faImages, faSpinner, faEdit, faExclamationTriangle, faChartBar, faLineChart, faNewspaper, faLightbulb, faStar, faUpload, faArrowLeft, faDownload } from '@fortawesome/free-solid-svg-icons';
import { getEnabledPlatforms } from '../utils/platformUtils';
import { validateInstagramImageFile, validateInstagramImageUrl, resizeForInstagram, blobToFile } from '../utils/instagramValidation';


const UpdatePendingPost = () => {
    const { ContentId } = useParams();
    const UserID = localStorage.getItem("UserID");
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [updatedContent, setUpdatedContent] = useState('');
    const [selectedPrompt, setSelectedPrompt] = useState('');
    const [promptData, setPromptData] = useState([]);
    const [regenerating, setRegenerating] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [image, setImage] = useState(null);
    const [selectedImagename, setSelectedImagename] = useState('');
    const [imagePreview, setImagePreview] = useState(null);
    const [videoPreview, setVideoPreview] = useState(null);
    const [fetchedImages, setFetchedImages] = useState([]);
    const [imageKeywords, setImageKeywords] = useState('');
    const [isFetchingImages, setIsFetchingImages] = useState(false);
    const [isRefreshingImages, setIsRefreshingImages] = useState(false); // Loading state for Refresh button
    const [isCraftingVisual, setIsCraftingVisual] = useState(false); // Loading state for Craft Visual button
    const [generatedTitle, setGeneratedTitle] = useState("");
    const [isQuestionsAvailable, setisQuestionsAvailable] = useState(false);
    const [isPollRequired, setIsPollRequired] = useState(false);
    const [questionData, setQuestionData] = useState({
        question: '',
        options: ['']
    });
    const [isDeleted, setIsDeleted] = useState(false);
    const fileInputRef = useRef(null);
    const [enabledPlatforms, setEnabledPlatforms] = useState([]);
    const [platformsLoading, setPlatformsLoading] = useState(true);

    const navigate = useNavigate();


    useEffect(() => {
        if (!ContentId) return; // Prevent API call if ContentId is missing

        const fetchPosts = async () => {
            setLoading(true);
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/api/getallgeneratedpostsbyContentId/${ContentId}`
                );

                if (response.data.length > 0) {
                    setUpdatedContent(response.data[0]?.Content || "");
                    setSelectedPrompt(response.data[0]?.Prompts || "");
                    setSelectedImagename(response.data[0]?.Image || "");
                    // Check if it's a poll by looking at QuestionwithOptions
                    const hasPollData = response.data[0]?.QuestionwithOptions && 
                                      response.data[0].QuestionwithOptions !== 'null' && 
                                      response.data[0].QuestionwithOptions !== '';
                    setIsPollRequired(hasPollData);
                }
                // Check if it's a poll by looking at QuestionwithOptions
                const hasPollData = response.data[0]?.QuestionwithOptions && 
                                  response.data[0].QuestionwithOptions !== 'null' && 
                                  response.data[0].QuestionwithOptions !== '';
                if (hasPollData) {
                    const qData = JSON.parse(response.data[0]?.QuestionwithOptions);

                    // Check if question and options are both empty
                    if (
                        (!qData.question || qData.question.trim() === '') &&
                        (!qData.options || qData.options.length === 0)
                    ) {
                        setIsDeleted(true); // set deletion flag
                    } else {
                        setQuestionData({
                            question: qData.question || '',
                            options: qData.options || ['', '']
                        });
                    }
                }
                else {
                    const title = await generateTitle(response.data[0]?.Content);
                    setGeneratedTitle(title);

                    // ✅ Await until images are fetched
                    await fetchImagesForTags(title);
                }
            } catch (err) {
                console.error("Failed to fetch posts:", err.message);
                setError("Failed to fetch posts");
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, [ContentId]);

    // Fetch enabled platforms for knack_feeds module
    useEffect(() => {
        const fetchPlatforms = async () => {
            setPlatformsLoading(true);
            const platforms = await getEnabledPlatforms('knackFeeds');
            setEnabledPlatforms(platforms);
            setPlatformsLoading(false);
        };
        fetchPlatforms();
    }, []);
    const generateTitle = async (content) => {
        try {
            // Check if content exists and is not empty
            if (!content || content.trim() === '') {
                console.log("Content is empty, skipping title generation");
                return "Untitled";
            }

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/generate-title`, {
                content,
            });

            return response.data.title;
        } catch (error) {
            console.error("Failed to generate title:", error.message);
            return "Untitled";
        }
    };
    // useEffect(() => {
    //     if (updatedContent?.trim()) {
    //         const hashtags = updatedContent.match(/#[\w]+/g) || [];
    //         fetchImagesForTags(hashtags.slice(-5));
    //     }
    // }, [updatedContent]);
    useEffect(() => {
        if (generatedTitle && !imageKeywords?.trim()) {
            fetchImagesForTags(generatedTitle);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generatedTitle]);

    const validateImage = async (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            const timeout = setTimeout(() => {
                resolve(null); // Timeout after 3 seconds
            }, 3000);
            
            img.onload = () => {
                clearTimeout(timeout);
                resolve(url);
            };
            img.onerror = () => {
                clearTimeout(timeout);
                resolve(null);
            };
            img.src = url;
        });
    };

    const fetchImagesForTags = async (tagsOrTitle) => {
        if (!tagsOrTitle) return;
        
        // Handle both array of tags and single title/string
        const query = Array.isArray(tagsOrTitle) ? tagsOrTitle.join(" ") : tagsOrTitle;
        
        try {
            const response = await axios.get("https://www.googleapis.com/customsearch/v1", {
                params: {
                    key: process.env.REACT_APP_GOOGLE_API_KEY,
                    cx: process.env.REACT_APP_GOOGLE_CSE_ID,
                    q: query,
                    searchType: "image",
                    num: 10,
                    rights: 'cc_publicdomain,cc_attribute',
                    safe: 'active',
                },
            });

            if (response.data.items) {
                // Validate only first 8 images in parallel (faster), with timeout
                const itemsToValidate = response.data.items.slice(0, 8);
                const imageLinks = await Promise.all(
                    itemsToValidate.map((item) => validateImage(item.link))
                );
                const validImages = imageLinks.filter((link) => link !== null);

                if (validImages.length === 0) {
                    setFetchedImages([]); // Ensure state is empty
                } else {
                    setFetchedImages(validImages);
                }
            } else {
                setFetchedImages([]);
            }
        } catch (error) {
            console.error("Error fetching images:", error);
            setFetchedImages([]);
        }
    };

    // Extract keywords from content for better image search
    const extractKeywordsFromContent = (content, originalPrompt) => {
        const keywords = [];
        
        // 1. Always include the original prompt (most relevant)
        if (originalPrompt?.trim()) {
            const promptWords = originalPrompt
                .split(/\s+/)
                .filter(word => word.length > 3 && !['the', 'and', 'for', 'are', 'but', 'not', 'you', 'all', 'can', 'her', 'was', 'one', 'our', 'out', 'day', 'get', 'has', 'him', 'his', 'how', 'its', 'may', 'new', 'now', 'old', 'see', 'two', 'way', 'who', 'boy', 'did', 'she', 'use', 'her', 'many', 'than', 'them'].includes(word.toLowerCase()))
                .slice(0, 5);
            keywords.push(...promptWords);
        }
        
        // 2. Extract hashtags from content
        const hashtags = content.match(/#[\w]+/g) || [];
        keywords.push(...hashtags.map(tag => tag.replace('#', '')));
        
        // 3. Extract key nouns/phrases from content
        const capitalizedWords = content.match(/\b[A-Z][a-z]+\b/g) || [];
        keywords.push(...capitalizedWords.slice(0, 3));
        
        // Remove duplicates and limit to 5-7 keywords
        const uniqueKeywords = [...new Set(keywords)].slice(0, 7);
        return uniqueKeywords.filter(k => k && k.length > 2);
    };

    // Function to fetch images with current keywords
    const fetchImagesWithKeywords = async (isRefresh = false) => {
        if (!updatedContent?.trim()) {
            return;
        }
        
        // Set appropriate loading state based on which button was clicked
        if (isRefresh) {
            setIsRefreshingImages(true);
        } else if (imageKeywords?.trim()) {
            setIsCraftingVisual(true);
        } else {
            setIsFetchingImages(true);
        }
        
        try {
            // If user has manually entered keywords, use those
            if (imageKeywords?.trim() && !isRefresh) {
                const manualKeywords = imageKeywords.split(',').map(k => k.trim()).filter(k => k);
                await fetchImagesForTags(manualKeywords);
                setIsCraftingVisual(false);
                return;
            }
            
            // Otherwise, use improved automatic extraction
            const extractedKeywords = extractKeywordsFromContent(updatedContent, selectedPrompt);
            console.log('Extracted keywords for images:', extractedKeywords);
            
            if (extractedKeywords.length > 0) {
                await fetchImagesForTags(extractedKeywords);
            } else {
                // Fallback: try to generate a title from the content
                try {
                    const title = await generateTitle(updatedContent);
                    if (title && title !== 'Untitled') {
                        await fetchImagesForTags([title]);
                    } else {
                        setFetchedImages([]);
                    }
                } catch (error) {
                    console.error('Error generating title:', error);
                    setFetchedImages([]);
                }
            }
        } catch (error) {
            console.error('Error fetching images:', error);
            setFetchedImages([]);
        } finally {
            setIsFetchingImages(false);
            setIsRefreshingImages(false);
            setIsCraftingVisual(false);
        }
    };


    const handlePromptChange = (e) => {
        setSelectedPrompt(e.target.value);
    };

    const handleRegenerate = async (ContentId, Prompts) => {
        setRegenerating(true);
        setImageKeywords(''); // Clear image keywords when regenerating
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/generateAIContentinUpdatepost`,
                { UserID, Prompts },
                { headers: { 'Content-Type': 'application/json' } }
            );

            const newContent = response.data.content;

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Post regenerated successfully',
                showConfirmButton: false,
                timer: 3000
            });

            setUpdatedContent(newContent);
        } catch (err) {
            console.error('Failed to regenerate post:', err.message);
            setError('Failed to regenerate post');
        } finally {
            setRegenerating(false);
        }
    };

    const [selectedImageUrl, setSelectedImageUrl] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMaximized, setIsMaximized] = useState(false);

    const handleSelectSuggestedImage = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setImage(null);
        setImagePreview(null);
        setVideoPreview(null);
        // setSelectedImagename(imageUrl);
        setIsModalOpen(true);
    };

    const handleDownloadImage = async (imageUrl, e) => {
        e.stopPropagation();
        try {
            // Fetch the image
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            
            // Create a download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            
            // Extract filename from URL or use default
            const urlParts = imageUrl.split('/');
            const filename = urlParts[urlParts.length - 1].split('?')[0] || 'downloaded-image.jpg';
            link.download = filename;
            
            // Trigger download
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading image:', error);
            Swal.fire({
                icon: 'error',
                title: 'Download Failed',
                text: 'Failed to download the image. Please try again.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#2e3192'
            });
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        
        // If no file selected (user cancelled), clear everything
        if (!file) {
            setImage(null);
            setSelectedImagename('');
            setImagePreview(null);
            setVideoPreview(null);
            return;
        }
        
        const maxSize = 50 * 1024 * 1024; // 50 MB in bytes

        if (file.size > maxSize) {
            Swal.fire({
                icon: 'error',
                title: 'File Size Exceeded',
                text: 'The file size should not exceed 50 MB.',
                showConfirmButton: true,
            });
            setImage(null);
            setSelectedImagename('');
            setImagePreview(null);
            setVideoPreview(null);
            return;
        }
        
        // File is valid, proceed with setting it
            setImage(file);
        setSelectedImagename(file.name || '');
        setSelectedImageUrl(null); // Clear AI image selection when uploading file
        
        // Create preview for image files
        if (file.type && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const result = e.target?.result || reader.result;
                if (result) {
                    setImagePreview(result);
                    setVideoPreview(null); // Clear video preview when image is selected
                }
            };
            reader.onerror = () => {
                console.error('Error reading image file');
                setImagePreview(null);
            };
            reader.readAsDataURL(file);
        } else if (file.type && file.type.startsWith('video/')) {
            // Create preview for video files
            const reader = new FileReader();
            reader.onload = (e) => {
                const result = e.target?.result || reader.result;
                if (result) {
                    setVideoPreview(result);
                    setImagePreview(null); // Clear image preview when video is selected
                }
            };
            reader.onerror = () => {
                console.error('Error reading video file');
                setVideoPreview(null);
            };
            reader.readAsDataURL(file);
        } else {
            setImagePreview(null);
            setVideoPreview(null);
        }
    };

    const handleApprove = async () => {
        try {
            console.log("Approving post with ContentId:", ContentId);

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/approve-post`,
                {
                    ContentId: ContentId, // 👈 Uppercase 'C'
                    Status: "APPROVED"    // 👈 Lowercase 's'
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data.message === 'Post approved successfully') {
                Swal.fire({
                    icon: 'success',
                    title: 'Post approved successfully',
                    showConfirmButton: false,
                    timer: 2000,
                });
            } else {
                throw new Error(response.data.message || "Approval failed");
            }
        } catch (err) {
            console.error("Approval error:", err.response?.data || err.message);
            
            // Check for validation errors (image/caption issues)
            const errorData = err.response?.data;
            if (errorData?.error && (errorData?.errorType === 'image_validation' || errorData?.errorType === 'caption_too_long' || errorData?.errorType === 'image_required')) {
                const platformName = errorData.platform === 'instagram' ? 'Instagram' : errorData.platform === 'facebook' ? 'Facebook' : errorData.platform;
                const errorDetails = errorData.errorDetails || {};
                
                // Handle caption too long error
                if (errorData?.errorType === 'caption_too_long') {
                    const captionLength = errorDetails.captionLength || 'N/A';
                    const maxLength = errorDetails.maxLength || 2200;
                    const charactersOver = errorDetails.charactersOver || 'N/A';
                    
                    Swal.fire({
                        icon: 'error',
                        title: `${platformName} Caption Too Long`,
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 10px;"><strong>${errorData.message}</strong></p>
                                ${captionLength !== 'N/A' ? `<p style="margin-bottom: 5px;">Current length: ${captionLength} characters</p>` : ''}
                                ${maxLength ? `<p style="margin-bottom: 5px;">Maximum allowed: ${maxLength} characters</p>` : ''}
                                ${charactersOver !== 'N/A' ? `<p style="margin-bottom: 5px; color: #e74c3c; font-weight: bold;">Characters over limit: ${charactersOver}</p>` : ''}
                                <p style="margin-top: 10px; color: #666;">Please shorten your caption to ${maxLength} characters or less before approving.</p>
                            </div>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                        width: '500px'
                    });
                    return;
                }
                
                // Handle image validation error
                if (errorData?.errorType === 'image_validation') {
                    const aspectRatio = errorDetails.aspectRatio || 'N/A';
                    const dimensions = errorDetails.dimensions || 'N/A';
                    
                    Swal.fire({
                        icon: 'error',
                        title: `${platformName} Image Error`,
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 10px;"><strong>${errorData.message}</strong></p>
                                ${dimensions !== 'N/A' ? `<p style="margin-bottom: 5px;">Image dimensions: ${dimensions}</p>` : ''}
                                ${aspectRatio !== 'N/A' ? `<p style="margin-bottom: 5px;">Aspect ratio: ${aspectRatio}:1</p>` : ''}
                                <p style="margin-top: 10px; color: #666;">Please upload a different image with a valid aspect ratio (between 0.8:1 and 1.91:1) before approving.</p>
                            </div>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                        width: '500px'
                    });
                    return;
                }
                
                // Handle image required error
                if (errorData?.errorType === 'image_required') {
                    Swal.fire({
                        icon: 'error',
                        title: `${platformName} Image Required`,
                        text: errorData.message || 'Image is required for this platform. Please add an image before approving.',
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192'
                    });
                    return;
                }
            }
            
            Swal.fire({
                icon: 'error',
                title: 'Approval Failed',
                text: err.response?.data?.message || err.message || "Something went wrong",
            });
        }
    };




    const handleSaveUpdate = async () => {
        if (!updatedContent) return;

        // Check if Instagram is enabled and validate image
        const isInstagramEnabled = enabledPlatforms.some(p => p.code === 'instagram' || p.name?.toLowerCase() === 'instagram');
        const hasImage = !!(image || selectedImageUrl || selectedImagename);
        
        if (isInstagramEnabled && !hasImage && !isPollRequired) {
            await Swal.fire({
                icon: 'error',
                title: 'Image Required for Instagram',
                html: `
                    <div style="text-align: left;">
                        <p style="margin-bottom: 15px;"><strong>Instagram requires an image to post.</strong></p>
                        <p style="margin-bottom: 20px; color: #666;">Please add an image to your post before updating for Instagram.</p>
                    </div>
                `,
                confirmButtonText: 'OK',
                confirmButtonColor: '#2e3192',
            });
            return;
        }

        // Validate Instagram image aspect ratio if Instagram is enabled and image exists
        if (isInstagramEnabled && hasImage && !isPollRequired) {
            try {
                let validationResult;
                
                if (image) {
                    // Validate uploaded file
                    validationResult = await validateInstagramImageFile(image);
                } else if (selectedImageUrl) {
                    // Validate selected image URL
                    validationResult = await validateInstagramImageUrl(selectedImageUrl);
                } else if (selectedImagename) {
                    // Validate existing image URL
                    validationResult = await validateInstagramImageUrl(selectedImagename);
                }
                
                if (validationResult && !validationResult.isValid) {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Invalid Image Aspect Ratio for Instagram',
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 15px;"><strong>${validationResult.error || 'Image does not meet Instagram requirements.'}</strong></p>
                                <p style="margin-bottom: 20px; color: #666;">Instagram requires images with aspect ratios between 0.8:1 and 1.91:1 (approximately 4:5 portrait to 1.91:1 landscape).</p>
                                <p style="color: #666;">Please select a different image with a valid aspect ratio.</p>
                            </div>
                        `,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                    });
                    return;
                }
            } catch (validationError) {
                console.error('Error validating Instagram image:', validationError);
                // If validation fails due to technical issues, warn but allow to proceed
                // (backend will catch it anyway)
                const result = await Swal.fire({
                    icon: 'warning',
                    title: 'Image Validation Warning',
                    text: 'Unable to validate image aspect ratio. The post will be updated, but Instagram may reject it if the aspect ratio is invalid.',
                    confirmButtonText: 'Continue',
                    confirmButtonColor: '#2e3192',
                    showCancelButton: true,
                    cancelButtonText: 'Cancel',
                    cancelButtonColor: '#6c757d',
                });
                
                if (!result.isConfirmed) {
                    return;
                }
            }
        }

        setLoading(true);
        // Add poll data
        let questionswithOptions = null;

        const hasValidQuestion = questionData.question.trim() !== '';
        const hasValidOptions = questionData.options.some(opt => opt.trim() !== '');

        if (hasValidQuestion && hasValidOptions) {
            questionswithOptions = {
                question: questionData.question.trim(),
                options: questionData.options.filter(opt => opt.trim() !== '')
            };
        }
        const formData = new FormData();
        formData.append('ContentId', ContentId);
        formData.append('UserID', UserID);
        formData.append('Content', updatedContent);
        formData.append('Prompts', selectedPrompt);
        formData.append('QuestionwithOptions', JSON.stringify(questionswithOptions));
        
        // ✅ Resize images for Instagram before appending to FormData
        if (image) {
            let imageToAppend = image;
            
            // Resize if Instagram is enabled and it's an image file
            if (isInstagramEnabled && !isPollRequired && image.type?.startsWith('image/')) {
                try {
                    console.log('📐 Resizing image to 1080x1080 (1:1) for Instagram...');
                    const resizedBlob = await resizeForInstagram(image);
                    
                    // Validate the resized blob
                    if (!resizedBlob || resizedBlob.size === 0) {
                        throw new Error('Resized image is empty or invalid');
                    }
                    
                    console.log('✅ Resized blob size:', resizedBlob.size, 'bytes');
                    imageToAppend = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                    
                    // Validate the file
                    if (!imageToAppend || imageToAppend.size === 0) {
                        throw new Error('Failed to convert resized blob to file');
                    }
                    
                    console.log('✅ Image resized successfully for Instagram (1080x1080), file size:', imageToAppend.size);
                } catch (resizeError) {
                    console.error('❌ Error resizing image for Instagram:', resizeError);
                    await Swal.fire({
                        icon: 'error',
                        title: 'Image Resize Failed',
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 10px;"><strong>Failed to resize image for Instagram:</strong></p>
                                <p style="margin-bottom: 10px; color: #666;">${resizeError.message || 'The image may be corrupted or invalid.'}</p>
                                <p style="margin-bottom: 10px; color: #666;">Please try:</p>
                                <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                    <li>Selecting a different image</li>
                                    <li>Or uploading an image from your device</li>
                                </ol>
                            </div>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192'
                    });
                    setLoading(false);
                    return;
                }
            }
            
            formData.append('image', imageToAppend); // Use resized image if Instagram is enabled
        } else if (selectedImageUrl) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/download-image?url=${encodeURIComponent(selectedImageUrl)}`);
                const blob = await response.blob();  // Convert to Blob
                const fileName = `image_${Date.now()}.jpg`; // Generate a filename
                let file = new File([blob], fileName, { type: blob.type }); // Create a File object

                // Resize if Instagram is enabled
                if (isInstagramEnabled && !isPollRequired) {
                    try {
                        console.log('📐 Resizing selected image to 1080x1080 (1:1) for Instagram...');
                        const resizedBlob = await resizeForInstagram(selectedImageUrl);
                        
                        // Validate the resized blob
                        if (!resizedBlob || resizedBlob.size === 0) {
                            throw new Error('Resized image is empty or invalid');
                        }
                        
                        console.log('✅ Resized blob size:', resizedBlob.size, 'bytes');
                        file = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                        
                        // Validate the file
                        if (!file || file.size === 0) {
                            throw new Error('Failed to convert resized blob to file');
                        }
                        
                        console.log('✅ Selected image resized successfully for Instagram (1080x1080), file size:', file.size);
                    } catch (resizeError) {
                        console.error('❌ Error resizing selected image for Instagram:', resizeError);
                        // Try one more time with the downloaded blob directly
                        try {
                            console.log('🔄 Retrying resize with downloaded blob...');
                            const resizedBlob = await resizeForInstagram(file);
                            
                            // Validate the resized blob
                            if (!resizedBlob || resizedBlob.size === 0) {
                                throw new Error('Resized image is empty or invalid on retry');
                            }
                            
                            file = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                            
                            // Validate the file
                            if (!file || file.size === 0) {
                                throw new Error('Failed to convert resized blob to file on retry');
                            }
                            
                            console.log('✅ Image resized successfully on retry, file size:', file.size);
                        } catch (retryError) {
                            console.error('❌ Retry also failed:', retryError);
                            await Swal.fire({
                                icon: 'error',
                                title: 'Image Resize Failed',
                                html: `
                                    <div style="text-align: left;">
                                        <p style="margin-bottom: 10px;"><strong>Failed to resize image for Instagram:</strong></p>
                                        <p style="margin-bottom: 10px; color: #666;">${resizeError.message || retryError.message || 'The image may be corrupted or invalid.'}</p>
                                        <p style="margin-bottom: 10px; color: #666;">Please try:</p>
                                        <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                            <li>Selecting a different image</li>
                                            <li>Or uploading an image from your device</li>
                                        </ol>
                                    </div>
                                `,
                                showConfirmButton: true,
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#2e3192'
                            });
                            setLoading(false);
                            return;
                        }
                    }
                }

                formData.append('image', file); // Append the resized file to FormData
            } catch (error) {
                console.error("❌ Error downloading image:", error);
                Swal.fire({
                    icon: 'error',
                    title: 'Image Fetch Error',
                    html: `
                        <div style="text-align: left;">
                            <p style="margin-bottom: 10px;"><strong>Failed to download image:</strong></p>
                            <p style="margin-bottom: 10px; color: #666;">${error.message || 'There was an issue fetching the image.'}</p>
                            <p style="color: #666;">Please try again later.</p>
                        </div>
                    `,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#2e3192'
                });
                setLoading(false);
                return;
            }
        } else {
            formData.append('image', selectedImagename || '');
        }

        try {
            const resp = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateContent`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            setLoading(false);

            if (resp.data.message === 'Post updated successfully') {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Post updated successfully',
                    showConfirmButton: false,
                    timer: 3000
                });

                setPosts(posts.map(post => post.ContentId === ContentId ?
                    { ...post, Content: updatedContent, image: selectedImageUrl || image } : post
                ));
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error updating post!',
                    showConfirmButton: false,
                    timer: 3000
                });
            }

            setIsUpdating(false);
        } catch (err) {
            console.error('Failed to update post:', err.response?.data || err.message);
            setLoading(false);
            
            // Check for validation errors (image/caption issues)
            const errorData = err.response?.data;
            if (errorData?.error && (errorData?.errorType === 'image_validation' || errorData?.errorType === 'image_required')) {
                const platformName = errorData.platform === 'instagram' ? 'Instagram' : errorData.platform === 'facebook' ? 'Facebook' : errorData.platform;
                const errorDetails = errorData.errorDetails || {};
                
                // Handle image validation error
                if (errorData?.errorType === 'image_validation') {
                    const aspectRatio = errorDetails.aspectRatio || 'N/A';
                    const dimensions = errorDetails.dimensions || 'N/A';
                    
                    Swal.fire({
                        icon: 'error',
                        title: `${platformName} Image Error`,
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 10px;"><strong>${errorData.message}</strong></p>
                                ${dimensions !== 'N/A' ? `<p style="margin-bottom: 5px;">Image dimensions: ${dimensions}</p>` : ''}
                                ${aspectRatio !== 'N/A' ? `<p style="margin-bottom: 5px;">Aspect ratio: ${aspectRatio}:1</p>` : ''}
                                <p style="margin-top: 10px; color: #666;">Please upload a different image with a valid aspect ratio (between 0.8:1 and 1.91:1) before updating.</p>
                            </div>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                        width: '500px'
                    });
                    setIsUpdating(false);
                    return;
                }
                
                // Handle image required error
                if (errorData?.errorType === 'image_required') {
                    Swal.fire({
                        icon: 'error',
                        title: `${platformName} Image Required`,
                        text: errorData.message || 'Image is required for this platform. Please add an image before updating.',
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192'
                    });
                    setIsUpdating(false);
                    return;
                }
            }
            
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error updating post!',
                text: err.response?.data?.message || err.message || 'Failed to update post',
                showConfirmButton: true
            });
            setIsUpdating(false);
        }
    };
    const handleSaveUpdate1 = async () => {
        if (!updatedContent) return;

        // Check if Instagram is enabled and validate image
        const isInstagramEnabled = enabledPlatforms.some(p => p.code === 'instagram' || p.name?.toLowerCase() === 'instagram');
        const hasImage = !!(image || selectedImageUrl || selectedImagename);
        
        if (isInstagramEnabled && !hasImage && !isPollRequired) {
            await Swal.fire({
                icon: 'error',
                title: 'Image Required for Instagram',
                html: `
                    <div style="text-align: left;">
                        <p style="margin-bottom: 15px;"><strong>Instagram requires an image to post.</strong></p>
                        <p style="margin-bottom: 20px; color: #666;">Please add an image to your post before updating and approving for Instagram.</p>
                    </div>
                `,
                confirmButtonText: 'OK',
                confirmButtonColor: '#2e3192',
            });
            return;
        }

        // Validate Instagram image aspect ratio if Instagram is enabled and image exists
        if (isInstagramEnabled && hasImage && !isPollRequired) {
            try {
                let validationResult;
                
                if (image) {
                    // Validate uploaded file
                    validationResult = await validateInstagramImageFile(image);
                } else if (selectedImageUrl) {
                    // Validate selected image URL
                    validationResult = await validateInstagramImageUrl(selectedImageUrl);
                } else if (selectedImagename) {
                    // Validate existing image URL
                    validationResult = await validateInstagramImageUrl(selectedImagename);
                }
                
                if (validationResult && !validationResult.isValid) {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Invalid Image Aspect Ratio for Instagram',
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 15px;"><strong>${validationResult.error || 'Image does not meet Instagram requirements.'}</strong></p>
                                <p style="margin-bottom: 20px; color: #666;">Instagram requires images with aspect ratios between 0.8:1 and 1.91:1 (approximately 4:5 portrait to 1.91:1 landscape).</p>
                                <p style="color: #666;">Please select a different image with a valid aspect ratio.</p>
                            </div>
                        `,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                    });
                    return;
                }
            } catch (validationError) {
                console.error('Error validating Instagram image:', validationError);
                // If validation fails due to technical issues, warn but allow to proceed
                // (backend will catch it anyway)
                const result = await Swal.fire({
                    icon: 'warning',
                    title: 'Image Validation Warning',
                    text: 'Unable to validate image aspect ratio. The post will be updated and approved, but Instagram may reject it if the aspect ratio is invalid.',
                    confirmButtonText: 'Continue',
                    confirmButtonColor: '#2e3192',
                    showCancelButton: true,
                    cancelButtonText: 'Cancel',
                    cancelButtonColor: '#6c757d',
                });
                
                if (!result.isConfirmed) {
                    return;
                }
            }
        }

        setLoading(true);
        let questionswithOptions = null;

        const hasValidQuestion = questionData.question.trim() !== '';
        const hasValidOptions = questionData.options.some(opt => opt.trim() !== '');

        if (hasValidQuestion && hasValidOptions) {
            questionswithOptions = {
                question: questionData.question.trim(),
                options: questionData.options.filter(opt => opt.trim() !== '')
            };
        }
        const formData = new FormData();
        formData.append('ContentId', ContentId);
        formData.append('UserID', UserID);
        formData.append('Content', updatedContent);
        formData.append('Prompts', selectedPrompt);
        formData.append('QuestionwithOptions', JSON.stringify(questionswithOptions));

        // ✅ Resize images for Instagram before appending to FormData
        if (image) {
            let imageToAppend = image;
            
            // Resize if Instagram is enabled and it's an image file
            if (isInstagramEnabled && !isPollRequired && image.type?.startsWith('image/')) {
                try {
                    console.log('📐 Resizing image to 1080x1080 (1:1) for Instagram...');
                    const resizedBlob = await resizeForInstagram(image);
                    
                    // Validate the resized blob
                    if (!resizedBlob || resizedBlob.size === 0) {
                        throw new Error('Resized image is empty or invalid');
                    }
                    
                    console.log('✅ Resized blob size:', resizedBlob.size, 'bytes');
                    imageToAppend = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                    
                    // Validate the file
                    if (!imageToAppend || imageToAppend.size === 0) {
                        throw new Error('Failed to convert resized blob to file');
                    }
                    
                    console.log('✅ Image resized successfully for Instagram (1080x1080), file size:', imageToAppend.size);
                } catch (resizeError) {
                    console.error('❌ Error resizing image for Instagram:', resizeError);
                    await Swal.fire({
                        icon: 'error',
                        title: 'Image Resize Failed',
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 10px;"><strong>Failed to resize image for Instagram:</strong></p>
                                <p style="margin-bottom: 10px; color: #666;">${resizeError.message || 'The image may be corrupted or invalid.'}</p>
                                <p style="margin-bottom: 10px; color: #666;">Please try:</p>
                                <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                    <li>Selecting a different image</li>
                                    <li>Or uploading an image from your device</li>
                                </ol>
                            </div>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192'
                    });
                    setLoading(false);
                    return;
                }
            }
            
            formData.append('image', imageToAppend); // Use resized image if Instagram is enabled
        } else if (selectedImageUrl) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/download-image?url=${encodeURIComponent(selectedImageUrl)}`);
                const blob = await response.blob();  // Convert to Blob
                const fileName = `image_${Date.now()}.jpg`; // Generate a filename
                let file = new File([blob], fileName, { type: blob.type }); // Create a File object

                // Resize if Instagram is enabled
                if (isInstagramEnabled && !isPollRequired) {
                    try {
                        console.log('📐 Resizing selected image to 1080x1080 (1:1) for Instagram...');
                        const resizedBlob = await resizeForInstagram(selectedImageUrl);
                        
                        // Validate the resized blob
                        if (!resizedBlob || resizedBlob.size === 0) {
                            throw new Error('Resized image is empty or invalid');
                        }
                        
                        console.log('✅ Resized blob size:', resizedBlob.size, 'bytes');
                        file = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                        
                        // Validate the file
                        if (!file || file.size === 0) {
                            throw new Error('Failed to convert resized blob to file');
                        }
                        
                        console.log('✅ Selected image resized successfully for Instagram (1080x1080), file size:', file.size);
                    } catch (resizeError) {
                        console.error('❌ Error resizing selected image for Instagram:', resizeError);
                        // Try one more time with the downloaded blob directly
                        try {
                            console.log('🔄 Retrying resize with downloaded blob...');
                            const resizedBlob = await resizeForInstagram(file);
                            
                            // Validate the resized blob
                            if (!resizedBlob || resizedBlob.size === 0) {
                                throw new Error('Resized image is empty or invalid on retry');
                            }
                            
                            file = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                            
                            // Validate the file
                            if (!file || file.size === 0) {
                                throw new Error('Failed to convert resized blob to file on retry');
                            }
                            
                            console.log('✅ Image resized successfully on retry, file size:', file.size);
                        } catch (retryError) {
                            console.error('❌ Retry also failed:', retryError);
                            await Swal.fire({
                                icon: 'error',
                                title: 'Image Resize Failed',
                                html: `
                                    <div style="text-align: left;">
                                        <p style="margin-bottom: 10px;"><strong>Failed to resize image for Instagram:</strong></p>
                                        <p style="margin-bottom: 10px; color: #666;">${resizeError.message || retryError.message || 'The image may be corrupted or invalid.'}</p>
                                        <p style="margin-bottom: 10px; color: #666;">Please try:</p>
                                        <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                            <li>Selecting a different image</li>
                                            <li>Or uploading an image from your device</li>
                                        </ol>
                                    </div>
                                `,
                                showConfirmButton: true,
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#2e3192'
                            });
                            setLoading(false);
                            return;
                        }
                    }
                }

                formData.append('image', file); // Append the resized file to FormData
            } catch (error) {
                console.error("❌ Error downloading image:", error);
                Swal.fire({
                    icon: 'error',
                    title: 'Image Fetch Error',
                    html: `
                        <div style="text-align: left;">
                            <p style="margin-bottom: 10px;"><strong>Failed to download image:</strong></p>
                            <p style="margin-bottom: 10px; color: #666;">${error.message || 'There was an issue fetching the image.'}</p>
                            <p style="color: #666;">Please try again later.</p>
                        </div>
                    `,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#2e3192'
                });
                setLoading(false);
                return;
            }
        } else {
            formData.append('image', selectedImagename || '');
        }

        try {
            const resp = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateContent`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            setLoading(false);

            if (resp.data.message === 'Post updated successfully') {
                await handleApprove();    // Then approve
                navigate('/viewallpendingposts');
                setPosts(posts.map(post => post.ContentId === ContentId ?
                    { ...post, Content: updatedContent, image: selectedImageUrl || image } : post
                ));
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error updating post!',
                    showConfirmButton: false,
                    timer: 3000
                });
            }

            setIsUpdating(false);
        } catch (err) {
            console.error('Failed to update post:', err.response?.data || err.message);
            setLoading(false);
            
            // Check for validation errors (image/caption issues)
            const errorData = err.response?.data;
            if (errorData?.error && (errorData?.errorType === 'image_validation' || errorData?.errorType === 'image_required')) {
                const platformName = errorData.platform === 'instagram' ? 'Instagram' : errorData.platform === 'facebook' ? 'Facebook' : errorData.platform;
                const errorDetails = errorData.errorDetails || {};
                
                // Handle image validation error
                if (errorData?.errorType === 'image_validation') {
                    const aspectRatio = errorDetails.aspectRatio || 'N/A';
                    const dimensions = errorDetails.dimensions || 'N/A';
                    
                    Swal.fire({
                        icon: 'error',
                        title: `${platformName} Image Error`,
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 10px;"><strong>${errorData.message}</strong></p>
                                ${dimensions !== 'N/A' ? `<p style="margin-bottom: 5px;">Image dimensions: ${dimensions}</p>` : ''}
                                ${aspectRatio !== 'N/A' ? `<p style="margin-bottom: 5px;">Aspect ratio: ${aspectRatio}:1</p>` : ''}
                                <p style="margin-top: 10px; color: #666;">Please upload a different image with a valid aspect ratio (between 0.8:1 and 1.91:1) before updating and approving.</p>
                            </div>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                        width: '500px'
                    });
                    setIsUpdating(false);
                    return;
                }
                
                // Handle image required error
                if (errorData?.errorType === 'image_required') {
                    Swal.fire({
                        icon: 'error',
                        title: `${platformName} Image Required`,
                        text: errorData.message || 'Image is required for this platform. Please add an image before updating and approving.',
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192'
                    });
                    setIsUpdating(false);
                    return;
                }
            }
            
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error updating post!',
                text: err.response?.data?.message || err.message || 'Failed to update post',
                showConfirmButton: true
            });
            setIsUpdating(false);
        }
    };
    const handleUpdateAndApprove = async () => {
        await handleSaveUpdate1(); // First update
        // await handleApprove();    // Then approve

        // navigate('/viewallpendingposts');
    };


    return (
        <SideNavbar>
            {loading ? <div className='spinner'></div> :
                <div className="card shadow-sm p-4 mt-3" style={{ border: 'none', backgroundColor: '#fff', borderRadius: '12px' }}>
                    {/* Header matching CreatePostPage */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '24px',
                        paddingBottom: '16px',
                        borderBottom: '1px solid #e0dfdc'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button
                                onClick={() => navigate('/viewallpendingposts')}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    marginRight: '12px',
                                    borderRadius: '4px',
                                    color: '#2e3192',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f3f2ef';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                }}
                            >
                                <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: '18px' }} />
                            </button>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundColor: '#2e3192',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '12px'
                            }}>
                                <FontAwesomeIcon icon={faEdit} style={{ color: 'white', fontSize: '18px' }} />
                            </div>
                            <div>
                                <h2 style={{ 
                                    color: '#000000',
                                    fontWeight: '600',
                                    fontSize: '20px',
                                    margin: '0 0 4px 0'
                                }}>
                                    Edit Post
                                </h2>
                                <p style={{ color: '#666666', margin: '0', fontSize: '14px' }}>
                                    Update and modify your post content
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="card-body" style={{ paddingTop: '0' }}>

                        {/* Prompt Input Section */}
                        <div style={{ marginBottom: '20px' }}>
                                <textarea
                                placeholder="What do you want to talk about?"
                                    value={selectedPrompt}
                                    onChange={handlePromptChange}
                                    style={{
                                    width: '100%',
                                    border: 'none',
                                        fontSize: '16px',
                                    padding: '16px 0',
                                    background: 'transparent',
                                    resize: 'none',
                                    outline: 'none',
                                    minHeight: '100px',
                                    fontFamily: 'inherit'
                                }}
                            />
                            {/* Toolbar */}
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'space-between',
                                paddingTop: '16px',
                                borderTop: '1px solid #e0dfdc'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    {/* Placeholder for future toolbar items */}
                            </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <button
                            onClick={() => handleRegenerate(ContentId, selectedPrompt)}
                            disabled={regenerating}
                                        style={{
                                            background: '#2e3192',
                                            border: 'none',
                                            color: 'white',
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            cursor: regenerating ? 'not-allowed' : 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            transition: 'all 0.3s ease',
                                            opacity: regenerating ? 0.7 : 1
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!regenerating) {
                                                e.target.style.backgroundColor = '#1c1f6d';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!regenerating) {
                                                e.target.style.backgroundColor = '#2e3192';
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faStar} style={{ fontSize: '14px' }} />
                            {regenerating ? 'Crafting...' : 'Craft'}
                        </button>
                                </div>
                            </div>
                        </div>
                        {/* Smart Content Section */}
                        <div style={{ marginBottom: '24px', marginTop: '24px' }}>
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '8px',
                                marginBottom: '12px'
                            }}>
                                <FontAwesomeIcon icon={faLightbulb} style={{ color: '#2e3192', fontSize: '18px' }} />
                                <h3 style={{ 
                                    margin: 0, 
                                    fontSize: '16px', 
                                    fontWeight: '600',
                                    color: '#000000'
                                }}>
                                    Smart Content
                                </h3>
                            </div>
                                <textarea
                                placeholder="AI-generated post content appears here..."
                                    value={updatedContent}
                                    onChange={(e) => {
                                        const content = e.target.value;
                                        if (content.length > 2950) {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: 'Content Length Exceeded',
                                                text: 'The content should not exceed 2950 characters.',
                                                showConfirmButton: true,
                                            });
                                        } else {
                                            setUpdatedContent(content);
                                        }
                                    }}
                                    style={{
                                    width: '100%',
                                    border: '1px solid #e0dfdc',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                    padding: '16px',
                                        background: '#FFFFFF',
                                    resize: 'vertical',
                                    outline: 'none',
                                    minHeight: '300px',
                                    fontFamily: 'inherit',
                                    lineHeight: '1.5'
                                    }}
                                />
                            </div>
                        {!isPollRequired &&
                            <><div style={{ marginTop: '24px', marginBottom: '24px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                    <h3 style={{ 
                                        margin: '0', 
                                        fontSize: '16px', 
                                        fontWeight: '600',
                                        color: '#000000'
                                    }}>
                                        AI Media Suggestions
                                    </h3>
                                    <button
                                        onClick={() => {
                                            setImageKeywords('');
                                            fetchImagesWithKeywords(true);
                                        }}
                                        disabled={isRefreshingImages || isCraftingVisual || !updatedContent?.trim()}
                                        style={{
                                            background: (isRefreshingImages || isCraftingVisual || !updatedContent?.trim()) ? '#cccccc' : '#2e3192',
                                            border: 'none',
                                            borderRadius: '6px',
                                            padding: '6px 12px',
                                            color: 'white',
                                            fontSize: '13px',
                                            fontWeight: '500',
                                            cursor: (isRefreshingImages || isCraftingVisual || !updatedContent?.trim()) ? 'not-allowed' : 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isRefreshingImages && !isCraftingVisual && updatedContent?.trim()) {
                                                e.target.style.backgroundColor = '#1a1d5c';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isRefreshingImages && !isCraftingVisual && updatedContent?.trim()) {
                                                e.target.style.backgroundColor = '#2e3192';
                                            }
                                        }}
                                        title="Refresh images using auto-extracted keywords from your prompt and content"
                                    >
                                        <FontAwesomeIcon 
                                            icon={isRefreshingImages ? faSpinner : faImages} 
                                            style={{ 
                                                fontSize: '12px',
                                                animation: isRefreshingImages ? 'spin 1s linear infinite' : 'none'
                                            }} 
                                        />
                                        {isRefreshingImages ? 'Searching...' : 'Refresh'}
                                    </button>
                                </div>
                                
                                {/* Image Keywords Input */}
                                {updatedContent?.trim() && (
                                    <div className="mb-3">
                                        <label style={{ 
                                            fontSize: '13px', 
                                            fontWeight: '500', 
                                            color: '#2e3192',
                                            marginBottom: '6px',
                                            display: 'block'
                                        }}>
                                            Image Keywords (Optional - comma-separated)
                                        </label>
                                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                            <input
                                                type="text"
                                                value={imageKeywords}
                                                onChange={(e) => setImageKeywords(e.target.value)}
                                                placeholder="e.g., business, technology, AI, innovation"
                                                style={{
                                                    flex: 1,
                                                    fontSize: '14px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #cfeafb',
                                                    background: '#FFFFFF',
                                                    padding: '8px 12px',
                                                    outline: 'none'
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && imageKeywords.trim()) {
                                                        fetchImagesWithKeywords(false);
                                                    }
                                                }}
                                            />
                                            <button
                                                onClick={() => fetchImagesWithKeywords(false)}
                                                disabled={isCraftingVisual || isRefreshingImages || !imageKeywords?.trim()}
                                                style={{
                                                    background: (isCraftingVisual || isRefreshingImages || !imageKeywords?.trim()) ? '#cccccc' : '#2e3192',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    padding: '8px 16px',
                                                    color: 'white',
                                                    fontSize: '13px',
                                                    fontWeight: '500',
                                                    cursor: (isCraftingVisual || isRefreshingImages || !imageKeywords?.trim()) ? 'not-allowed' : 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    transition: 'all 0.3s ease',
                                                    whiteSpace: 'nowrap'
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!isCraftingVisual && !isRefreshingImages && imageKeywords?.trim()) {
                                                        e.target.style.backgroundColor = '#1a1d5c';
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!isCraftingVisual && !isRefreshingImages && imageKeywords?.trim()) {
                                                        e.target.style.backgroundColor = '#2e3192';
                                                    }
                                                }}
                                                title="Generate images using your keywords"
                                            >
                                                <FontAwesomeIcon 
                                                    icon={isCraftingVisual ? faSpinner : faImage} 
                                                    style={{ 
                                                        fontSize: '12px',
                                                        animation: isCraftingVisual ? 'spin 1s linear infinite' : 'none'
                                                    }} 
                                                />
                                                {isCraftingVisual ? 'Crafting...' : 'Craft Visual'}
                                            </button>
                                        </div>
                                        <p style={{ 
                                            fontSize: '11px', 
                                            color: '#6c757d', 
                                            marginTop: '4px',
                                            marginBottom: '12px'
                                        }}>
                                            Enter keywords and click "Craft Visual" to generate images, or leave empty and use "Refresh" for auto-extraction
                                        </p>
                                    </div>
                                )}

                                {(isFetchingImages || isRefreshingImages || isCraftingVisual) ? (
                                    <div className="text-center p-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2 text-muted small">Fetching images...</p>
                                    </div>
                                ) : fetchedImages.length > 0 ? (
                                <div className="row" style={{ gap: '4px' }}>
                                    {fetchedImages.map((img, index) => (
                                        <div key={index} className="col-4 col-md-3 col-lg-2 col-xl-2">
                                            <div 
                                                className="position-relative"
                                                style={{ 
                                                    aspectRatio: "1",
                                                    borderRadius: "6px",
                                                    overflow: "hidden",
                                                    cursor: "pointer",
                                                    border: selectedImageUrl === img ? "2px solid #2e3192" : "1px solid transparent",
                                                    transition: "all 0.2s ease",
                                                    backgroundColor: "#f7fafc",
                                                    maxWidth: "120px"
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (selectedImageUrl !== img) {
                                                        e.currentTarget.style.borderColor = "#cbd5e0";
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (selectedImageUrl !== img) {
                                                        e.currentTarget.style.borderColor = "transparent";
                                                    }
                                                }}
                                                onClick={() => handleSelectSuggestedImage(img)}
                                            >
                                                <img
                                                    src={img}
                                                    alt="Suggested"
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        display: "block"
                                                    }}
                                                />
                                                
                                                {/* Top-right checkbox */}
                                                <div
                                                    className="position-absolute"
                                                    style={{ 
                                                        top: "6px", 
                                                        right: "6px",
                                                        width: "22px",
                                                        height: "22px",
                                                        borderRadius: "50%",
                                                        backgroundColor: selectedImagename === img ? "#2e3192" : "rgba(255, 255, 255, 0.95)",
                                                        border: selectedImagename === img ? "none" : "2px solid rgba(0, 0, 0, 0.2)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        cursor: "pointer",
                                                        transition: "all 0.15s ease",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)"
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const newChecked = !(selectedImagename === img);
                                                        setSelectedImagename(newChecked ? img : null);
                                                        setSelectedImageUrl(newChecked ? img : null);
                                                        if (newChecked) {
                                                            setImage(null);
                                                            setImagePreview(null);
                                                            setVideoPreview(null);
                                                        }
                                                    }}
                                                >
                                                    {selectedImagename === img && (
                                                        <FontAwesomeIcon 
                                                            icon={faCheck} 
                                                            style={{ 
                                                                color: "#fff", 
                                                                fontSize: "10px"
                                                            }} 
                                                        />
                                                    )}
                                            </div>
                                                
                                                {/* Bottom action buttons overlay */}
                                                <div
                                                    className="position-absolute d-flex gap-2"
                                                    style={{
                                                        bottom: "8px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                        opacity: selectedImageUrl === img ? "1" : "0",
                                                        transition: "opacity 0.2s ease"
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.opacity = "1";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (selectedImageUrl !== img) {
                                                            e.currentTarget.style.opacity = "0";
                                                        }
                                                    }}
                                                >
                                                    <button
                                                        className="btn btn-sm"
                                                        style={{
                                                            minWidth: "32px",
                                                            height: "32px",
                                                            padding: "0",
                                                            borderRadius: "6px",
                                                            backgroundColor: "rgba(255, 255, 255, 0.95)",
                                                            border: "none",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        setSelectedImageUrl(img);
                                                        setImage(null);
                                                        setImagePreview(null);
                                                        setVideoPreview(null);
                                                        setIsModalOpen(true);
                                                        }}
                                                        title="View Full Image"
                                                    >
                                                        <FontAwesomeIcon icon={faImage} style={{ color: "#2e3192", fontSize: "12px" }} />
                                                    </button>
                                                    
                                                    <button
                                                        className="btn btn-sm"
                                                        style={{
                                                            minWidth: "32px",
                                                            height: "32px",
                                                            padding: "0",
                                                        
                                                            borderRadius: "6px",
                                                            backgroundColor: "rgba(255, 255, 255, 0.95)",
                                                            border: "none",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                            display: "none",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                        onClick={(e) => handleDownloadImage(img, e)}
                                                        title="Download Image"
                                                    >
                                                        <FontAwesomeIcon icon={faDownload} style={{ color: "#2e3192", fontSize: "12px" }} />
                                                    </button>
                                                    
                                                    <button
                                                        className="btn btn-sm"
                                                        style={{
                                                            minWidth: "32px",
                                                            height: "32px",
                                                            padding: "0",
                                                            borderRadius: "6px",
                                                            backgroundColor: "#2e3192",
                                                            border: "none",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                            display: "none",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        setSelectedImagename(img);
                                                        setSelectedImageUrl(img);
                                                        setImage(null);
                                                        setImagePreview(null);
                                                        setVideoPreview(null);
                                                        }}
                                                        title="Select This Image"
                                                    >
                                                        <FontAwesomeIcon icon={faCheck} style={{ color: "#fff", fontSize: "12px" }} />
                                                    </button>
                                                </div>
                                                
                                                {/* Hover overlay */}
                                                {selectedImageUrl !== img && (
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            backgroundColor: "rgba(0, 0, 0, 0)",
                                                            transition: "background-color 0.2s ease",
                                                            pointerEvents: "none"
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.05)";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0)";
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                ) : (
                                    <div className="text-center p-4" style={{ 
                                        border: '1px dashed #dee2e6', 
                                        borderRadius: '8px', 
                                        backgroundColor: '#f8f9fa',
                                        color: '#6c757d'
                                    }}>
                                        <FontAwesomeIcon icon={faImage} style={{ fontSize: '2rem', color: '#adb5bd', marginBottom: '10px' }} />
                                        <p className="mb-0 small">
                                            No images found for this content. Try adding hashtags to your prompt or enter keywords.
                                        </p>
                                    </div>
                                )}
                                <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} size={isMaximized ? "xl" : "lg"} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Image Preview</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="text-center">
                                        <img
                                            src={selectedImageUrl}
                                            alt="Selected"
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: isMaximized ? "90vh" : "70vh",
                                                objectFit: "contain",
                                            }} />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
                                            Close
                                        </Button>
                                        <Button variant="primary" onClick={() => setIsMaximized(!isMaximized)}>
                                            {isMaximized ? "Minimize" : "Maximize"}
                                        </Button>
                                        <Button variant="success" onClick={() => {
                                            if (selectedImageUrl) {
                                                setSelectedImagename(selectedImageUrl);
                                                setSelectedImageUrl(selectedImageUrl);
                                                setImage(null); // Clear any uploaded file
                                                setImagePreview(null);
                                                setVideoPreview(null);
                                                setIsModalOpen(false);
                                            }
                                        }}>
                                            Select Image
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                                <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept="image/*,video/*"
                                        style={{ display: 'none' }}
                                        onChange={(e) => {
                                            handleImageChange(e);
                                            setSelectedImageUrl(null);
                                        }} />
                                    <button
                                        type="button"
                                        onClick={() => fileInputRef.current?.click()}
                                        title="Upload Image or Video"
                                        style={{
                                            fontSize: '16px',
                                            borderRadius: '50%',
                                            border: 'none',
                                            background: '#2e3192',
                                            padding: '12px',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '48px',
                                            height: '48px',
                                            minWidth: '48px',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#1a1d5c';
                                            e.target.style.transform = 'scale(1.05)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#2e3192';
                                            e.target.style.transform = 'scale(1)';
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faUpload} />
                                    </button>
                                    {(selectedImagename || selectedImageUrl) && (
                                        <div style={{ marginTop: '12px' }}>
                                        <p style={{ 
                                                marginBottom: '10px',
                                                fontWeight: 'bold', 
                                                color: '#2e3192', 
                                                fontSize: '14px' 
                                            }}>
                                                Selected: {selectedImageUrl ? 'AI Suggested Image' : (image && image.type && image.type.startsWith('video/')) ? 'Uploaded Video' : 'Uploaded Image'}
                                            </p>
                                            {selectedImageUrl ? (
                                                // Show AI selected image preview
                                                <div>
                                                    <img
                                                        src={selectedImageUrl}
                                                        alt="Selected AI Image"
                                                        style={{
                                                            width: "150px",
                                                            height: "150px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "2px solid #2e3192"
                                                        }}
                                                        onError={(e) => {
                                                            console.error('Error loading AI image preview:', e);
                                                        }}
                                                        onLoad={() => {
                                                            console.log('AI image preview loaded successfully');
                                                        }}
                                                    />
                                                </div>
                                            ) : imagePreview ? (
                                                // Show uploaded image preview
                                                <div>
                                                    <img
                                                        src={imagePreview}
                                                        alt="Uploaded"
                                                        style={{
                                                            width: "150px",
                                                            height: "150px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "2px solid #2e3192"
                                                        }}
                                                        onError={(e) => {
                                                            console.error('Error loading image preview:', e);
                                                            setImagePreview(null);
                                                        }}
                                                        onLoad={() => {
                                                            console.log('Image preview loaded successfully');
                                                        }}
                                                    />
                                                </div>
                                            ) : videoPreview ? (
                                                // Show uploaded video preview
                                                <div>
                                                    <video
                                                        src={videoPreview}
                                                        controls
                                                        style={{
                                                            width: "200px",
                                                            maxHeight: "200px",
                                                            borderRadius: "8px",
                                                            border: "2px solid #2e3192"
                                                        }}
                                                    >
                                                        Your browser does not support the video tag.
                                                    </video>
                                                </div>
                                            ) : (
                                                <p style={{ 
                                            color: '#666666', 
                                            fontSize: '14px' 
                                        }}>
                                                    {selectedImagename}
                                        </p>
                                            )}
                                        </div>
                                    )}
                                </div>
                                </div></>
                        }
                        {!isDeleted && isPollRequired && (
                            <div className="question-editor">
                                <label>Poll Question:</label>
                                <input
                                    type="text"
                                    value={questionData.question}
                                    onChange={(e) =>
                                        setQuestionData({ ...questionData, question: e.target.value })
                                    }
                                    placeholder="Enter your question"
                                    className="form-control mb-2"
                                />

                                <label>Options:</label>
                                {questionData.options.map((opt, idx) => (
                                    <div key={idx} className="d-flex align-items-center mb-2">
                                        <input
                                            type="text"
                                            value={opt}
                                            onChange={(e) => {
                                                const newOptions = [...questionData.options];
                                                newOptions[idx] = e.target.value;
                                                setQuestionData({ ...questionData, options: newOptions });
                                            }}
                                            className="form-control me-2"
                                        />
                                        {questionData.options.length > 2 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => {
                                                    const newOptions = questionData.options.filter((_, i) => i !== idx);
                                                    setQuestionData({ ...questionData, options: newOptions });
                                                }}
                                            >
                                                <i
                                                    className="fa fa-trash text-white"
                                                    style={{ cursor: "pointer", color: '#fff' }}
                                                    title="Remove Option"

                                                ></i>
                                            </button>
                                        )}
                                    </div>
                                ))}

                                {questionData.options.length < 4 && (

                                    <button style={{ backgroundColor: '#2e3192', marginRight: 10 }} onClick={() =>
                                        setQuestionData({ ...questionData, options: [...questionData.options, ''] })
                                    }> <i
                                        className="fa fa-plus text-white"
                                        style={{ cursor: "pointer" }}
                                        title="Add Option"
                                    ></i></button>
                                )}
                            </div>
                        )}



                        {/* Action Buttons */}
                        <div style={{ 
                            display: 'flex', 
                            gap: '8px', 
                            marginTop: '24px',
                            paddingTop: '16px',
                            borderTop: '1px solid #e0dfdc'
                        }}>
                            <button
                                onClick={handleSaveUpdate}
                                style={{
                                    background: '#2e3192',
                                    border: 'none',
                                    color: 'white',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#1c1f6d';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#2e3192';
                                }}
                            >
                                Update
                            </button>
                            <button
                                onClick={handleUpdateAndApprove}
                                style={{
                                    background: '#2e3192',
                                    border: 'none',
                                    color: 'white',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#1c1f6d';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#2e3192';
                                }}
                            >
                                Update and Approve
                            </button>
                        </div>

                    </div>
                </div>
            }
            <style>
                {`
          .file-input {
            display: none;
          }

          .custom-btn {
            display: inline-block;
            padding: 10px 20px;
            background-color: #2e3192;
            color: white;
            border-radius: 5px;
            cursor: pointer;
            text-align: center;
          }

          .custom-btn:hover {
            background-color: #1c1f6d;
          }
        `}
            </style>
        </SideNavbar>
    );
};

export default UpdatePendingPost;
